import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import KPIComparator from "components/visuals/KPIComparator";

import { useAppSelector } from "store";
import { selectComparator, selectStore } from "modules/customer/insights/portfolio/portfolioSlice";
import { selectors } from "modules/customer/insights/portfolio/competition/localAreaCompetition";

const NumberOfComp = () => {
    const selectedStore = useAppSelector(selectStore);
    const selectedComparator = useAppSelector(selectComparator);
    const numberOfComp = useSelector(state => selectors.numberOfComp(state));
    const { loading, error, value, percentageDifference } = numberOfComp;
    const valueFormatted = value.toString();
    const label = `${selectedStore.name} Store Number of Competitors vs ${selectedComparator.name}`;

    return (
        <Box width="100%" height="100%" data-cy="number-of-comp">
            <KPIComparator loading={loading} error={error} label={label} value={valueFormatted} percentage={percentageDifference} switchColor={true} />
        </Box>
    );
};

export default NumberOfComp;
